<template>
  <v-list two-line>
    <template v-for="(item,i) in history">
      <v-divider :key="'d-' + i" v-if="i>0" />
  
      <v-list-item 
        class="px-4" style="font-size: 14px"
        :to="linkByCategory(item)"
        :key="'hi-' + i"
      >
        <!-- only one of these is happening   -->
        <DisputeHistoryItem v-if="item.category == 'Dispute'" :item="item" />
        <LeadPurchaseHistoryItem v-if="item.category == 'Lead Purchase'" :item="item" />
        <CreditHistoryItem v-if="item.category == 'Payment'" :item="item"/>
        <RefundHistoryItem v-if="item.category == 'Refund'" :item="item" />
        <RenewalHistoryItem v-if="item.category == 'Membership Renewal'" :item="item" />
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import HistoryItems from './HistoryItems'

export default {
  name: 'BillingHistoryList',

  components: { ...HistoryItems },

  props: {
    disputable: {
      type: Boolean,
      default: false,
    },
    history:  {
      type:  Array,
      required: true,
    },
  },

  methods: {
    linkByCategory(item) {
      switch(item.category) {
        case 'Dispute':
          return { name: 'leads', params: { lead_id: item.lead_id } }
        case 'Lead Purchase':
          if (this.disputable) {
            return { name: 'history/dispute/create', params: { lead_id: item.lead_id } }
          } else {
            return { name: 'leads', params: { lead_id: item.lead_id } }
          }
        case 'Payment':
          return { name: 'billing/payments', query: { payment_id: item.payment_id } }
        case 'Refund':
          return  { name: 'leads', params: { lead_id: item.lead_id } }
        case 'Membership Renewal':
          return { name: 'billing/account' }
        default:
          return { name: 'home' }
      }
    }
  }
}
</script>